(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[76439],{

/***/ 22147:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Color name source http://www.htmlcsscolor.com/
 */ /* harmony default export */ __webpack_exports__["Z"] = ({
    light: "#FFFFFF",
    highempahis: "#333333",
    highgray: "#969696",
    midgray: "#B5B5B5",
    lowgray: "#CBCBCB",
    downgray: "#EDEDED",
    component: "#F5F5F5",
    primary: "#00ab6b",
    "primary60%": "#00ab6b99",
    secondary: "#3b5998",
    trading: "#2facb2",
    gainsboro: "#DADADA",
    whisper: "#EEEEEE",
    silver: "#BBBBBB",
    aliceBlue: "#F5F6F7",
    snow: "#F9F9F9",
    dimgray: "#6b6b6b",
    black: "#000000",
    nightRider: "#333333",
    zambezi: "#595959",
    veryLightGrey: "#CCCCCC",
    suvaGrey: "#939393",
    highball: "#979134",
    sunsetOrange: "#ee4a49",
    clearDay: "#e6f8f1",
    darkGray: "#AAAAAA",
    dimGray: "#666666",
    mintCream: "#eafff7",
    nobel: "#999999",
    bubbles: "#DEF2E5",
    heather: "#B5B6B7",
    bermuda: "#80D5B5",
    sundown: "#F7A5A4",
    hummingBird: "#cceee1",
    coralCandy: "#FAC8C8",
    darkGrey: "#AAAAAA",
    valencia: "#d9534f",
    mischka: "#a2a7b0",
    royalBlue: "#5766D3",
    steelBlue: "#4178bb",
    scooter: "#2c8aa3",
    java: "#169b8b",
    jade: "#00ad73",
    /* handling hex code with duplicate name */ "seasonality-darkest-green": "#006c00",
    "seasonality-medium-green": "#018601",
    "seasonality-green": "#009b00",
    "seasonality-bright-green": "#01ad01",
    "seasonality-darkest-red": "#a70000",
    "seasonality-medium-red": "#c20d0d",
    "seasonality-red": "#d00808",
    "seasonality-bright-red": "#e70000",
    amber: "#ffbf00",
    mintTulip: "#bde9d9",
    dodgerBlue: "#1E90FF",
    navyBlue: "#136ad5",
    whiteSmoke: "#F2F2F2",
    pigmentGreen: "#019934",
    lightGreen: "#90E897",
    monaLisa: "#ff988e",
    purpleHeart: "#7924c3",
    venetianRed: "#c11214",
    green: "#0c8414",
    cadetBlue: "#49a3ac",
    pinkSwan: "#B6B6B6",
    grannyApple: "#C7F3CB",
    alertRed: "#FCD0CE",
    alertOrange: "#F0AD4E",
    alertBlue: "#337AB7",
    yellowSea: "#eba031",
    chardonnay: "#ffc774",
    softgreen: "#E5F7F0",
    mountainMeadow: "#0bba7a",
    grey: "#777777",
    nero: "#222222",
    ghostWhite: "#f8f8f9",
    azureBlue: "#2F8EF7",
    bitterSweet: "#fc605c",
    supernova: "#fdbc40",
    limeGreen: "#34c84a",
    softGainsboro: "#DDDDDD",
    mediumAquamarine: "#5dcbad",
    cosmicLatte: "#e1f6e5",
    vividViolet: "#712E9E"
});


/***/ }),

/***/ 74575:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    mobileS: "(min-width:320px)",
    mobileM: "(min-width:375px)",
    mobileL: "(min-width:425px)",
    tablet: "(min-width:768px)",
    laptop: "(min-width:1024px)",
    laptopL: "(min-width:1440px)",
    desktop: "(min-width:2560px)"
});


/***/ }),

/***/ 70821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: ",
        ";\n  align-items: ",
        ";\n  padding: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  flex-wrap: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Flex = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        direction: props.direction || "row",
        justify: props.justify || "left",
        align: props.align || "flex-start",
        padding: props.padding || "0",
        margin: props.margin || "0",
        width: props.width,
        height: props.height,
        wrap: props.wrap || "nowrap"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-d08cd954-0"
})(_templateObject(), function(param) {
    var direction = param.direction;
    return direction;
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var wrap = param.wrap;
    return wrap;
}, _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (Flex);


/***/ }),

/***/ 95541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52435);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n  padding: ",
        ";\n  width: ",
        ";\n  text-transform: ",
        ";\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  & > a {\n    color: ",
        ";\n    text-decoration: none;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var familyType = {
    regular: "ProximaNovaRg",
    light: "ProximaNovaLt",
    bold: "ProximaNovaBd"
};
/* harmony default export */ __webpack_exports__["Z"] = (styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "ellipsis",
            "textTransform"
        ].includes(prop);
    }
}).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        size: props.size || "14px",
        weight: props.weight || "normal",
        height: props.height || "normal",
        color: props.color || _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis,
        align: props.align || "left",
        padding: props.padding || 0,
        width: props.width,
        ellipsis: props.ellipsis,
        textTransform: props.textTransform,
        family: props.family || "regular"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-8a078c1d-0"
})(_templateObject3(), function(param) {
    var family = param.family;
    return familyType[family];
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var weight = param.weight;
    return weight;
}, function(param) {
    var height = param.height;
    return height;
}, function(props) {
    return props.color;
}, function(param) {
    var align = param.align;
    return align;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var textTransform = param.textTransform;
    return textTransform;
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}, function(param) {
    var ellipsis = param.ellipsis;
    return ellipsis && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props));
}));


/***/ }),

/***/ 52435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ spacingProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);




var types = {
    m: "margin",
    p: "padding"
};
var directions = {
    t: [
        "-top"
    ],
    r: [
        "-right"
    ],
    b: [
        "-bottom"
    ],
    l: [
        "-left"
    ],
    x: [
        "-left",
        "-right"
    ],
    y: [
        "-top",
        "-bottom"
    ]
};
var EMPTY_STRING = "";
var WHITE_SPACE = " ";
var REGEX = /^([mp][trblxy]?)$/;
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(prev, f) {
            return f(prev, x);
        }, x);
    };
};
var filter = function(keys) {
    return keys.filter(function(key) {
        return key.match(REGEX);
    });
};
var merge = function(props) {
    return props.map(function(param) {
        var type = param.type, direction = param.direction, value = param.value;
        return direction.map(function(d) {
            return "".concat(type).concat(d, ": ").concat(value, ";");
        }).join(WHITE_SPACE);
    });
};
var splitPropKey = function(keys, props) {
    return keys.map(function(key) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key.split(""), 2), type = ref[0], direction = ref[1];
        return {
            type: types[type],
            direction: directions[direction] || [
                EMPTY_STRING
            ],
            value: props[key]
        };
    });
};
var handleSpaces = function(props) {
    return pipe(Object.keys, filter, splitPropKey, merge)(props).join(WHITE_SPACE);
};
var spacingProps = function(props) {
    var typesKeys = Object.keys(types);
    var directionsKeys = Object.keys(directions);
    var result = typesKeys.map(function(type) {
        return directionsKeys.map(function(dir) {
            return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, "".concat(type).concat(dir), props["".concat(type).concat(dir)]);
        });
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(prev).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(curr));
    }, []).filter(function(prop) {
        return Object.values(prop)[0];
    }).reduce(function(prev, curr) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prev, curr);
    }, {});
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, result);
};
/* harmony default export */ __webpack_exports__["Z"] = (handleSpaces);


/***/ }),

/***/ 23443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ toolsFeatures; },
/* harmony export */   "Z": function() { return /* binding */ ASSET_URL; }
/* harmony export */ });
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);

var ASSET_URL = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_0__/* .assetPrefix */ .Vc, "/homepage/proimage/");
var toolsFeatures = [
    {
        title: "Financials",
        url: "financials",
        description: "Pelajari Data Laporan Keuangan",
        icon: "landingicon_Financials.svg",
        features: [
            {
                title: "Berbagai Tampilan Periode",
                description: "Pilih periode data keuangan perusahaan yang ingin kamu liat, mulai dari per kuartal (Quarterly), tahunan (Annual), 12 bulan kebelakang (TTM) ataupun Year-To-Date (YTD)."
            },
            {
                title: "Grafik Tren & Rasio Keuangan",
                description: "Lihat tren pendapatan, laba bersih dan akun lainnya berdasarkan data historikal. Juga dilengkapi rasio keuangan untuk memudahkan analisa Anda."
            },
            {
                title: "Pertumbuhan Perusahaan",
                description: "Cari tau bagaimana pertumbuhan pendapatan atau laba bersih perusahaan sesuai periode yang diinginkan, Quarter-on-Quarter atau Year-on-Year hanya dengan 2 klik."
            },
            {
                title: "Marjin Perusahaan",
                description: "Pelajari dan bandingkan marjin yang dihasilkan perusahaan antar periode. Apakah itu Gross Profit Margin ataupun Net Profit Margin."
            },
            {
                title: "Drag n Drop",
                description: "Bandingkan periode yang kamu butuhkan side by side hanya dengan drag and drop, kamu juga bisa atur sendiri susunan periode laporan keuangan sesuai kebutuhan"
            },
            {
                title: "IDR atau USD",
                description: "Beberapa perusahaan menggunakan USD dalam laporannya, dengan financials kamu bisa liat laporannya tetap dalam USD atau dalam IDR, rubah sesuai kebutuhanmu."
            }, 
        ]
    },
    {
        title: "Keystats",
        url: "keystats",
        description: "Rasio-rasio Fundamental yang Lengkap",
        icon: "landingicon_Keystats.svg",
        features: [
            {
                title: "Valuasi nilai Perusahaan",
                description: "Pelajari data valuasi penting emiten seperti PE ratio, Earning Yield, PBV ratio. Semua dari satu tempat."
            },
            {
                title: "Level Hutang",
                description: "Cari tahu keadaan kesehatan perusahaan dengan melihat level hutang dari rasio-rasio Solvency seperti Current ratio, Debt to Equity ratio, Interest Coverage dan lainnya."
            },
            {
                title: "Alokasi Kas",
                description: "Ketahui dan pelajari Berasal dari mana dan digunakan untuk apa kas yang dimiliki oleh emiten."
            },
            {
                title: "Deviden",
                description: "Liat informasi terkait pembagian dividend perusahaan, berapa jumlah dividend per share yang dibagikan, berapa payout ratio dan berapa besar dividend yield."
            }, 
        ]
    },
    {
        title: "Fundachart",
        url: "fundachart",
        description: "Bandingkan Data Emiten secara Visual",
        icon: "landingicon_Fundachart.svg",
        features: [
            {
                title: "PE Standard Deviation Band",
                description: "Salah satu metode yang sering dipakai oleh institusi untuk melakukan valuasi saham untuk mengetahui apakah saham termasuk murah atau mahal berdasarkan historikal PE Ratio-nya."
            },
            {
                title: "PE Price Band",
                description: "Lihat langsung apakah harga saham saat ini termasuk murah atau mahal. Tentukan dengan mudah titik harga untuk masuk atau keluar dari sebuah saham."
            },
            {
                title: "PBV Standard Deviation Band",
                description: "Salah satu metode yang juga sering digunakan oleh institusi untuk melakukan valuasi saham berdasarkan historikal Price to Book Value-nya."
            }, 
        ]
    },
    {
        title: "Chartbit",
        url: "chartbit",
        description: "Fitur Charting Professional",
        icon: "landingicon_Chartbit.svg",
        features: [
            {
                title: "Real-time Price",
                description: "Data harga yang sama dengan data harga di bursa saat itu juga."
            },
            {
                title: "Intraday Price Interval",
                description: "Periode Harga mulai dari 1 menit, 5,menit, 30 menit, sampai 1 jam."
            },
            {
                title: "Data historikal hingga 15 tahun",
                description: "Lihat trend harga saham sampai dengan 15 tahun kebelakang untuk menganalisa trend jangka panjang."
            },
            {
                title: "100+ Teknikal Indikator",
                description: "Tersedia ratusan indikator siap pakai untuk mempertajam analisa teknikal Anda."
            },
            {
                title: "Bandarmologi",
                description: 'Deteksi dan pelajari gerak bandar, jadilah "teman" bandar untuk membantu kamu mendapatkan keuntungan.'
            },
            {
                title: "Foreign Flow",
                description: "Pantau pergerakan dana asing di saham pilihanmu, apakah net inflow atau outflow. Pelajari juga seberapa kuat transaksi dana asing pada saham tersebut."
            },
            {
                title: "Corporate Action Event",
                description: "Lihat langsung aksi korporasi dan pengaruhnya terhadap pergerakan harga sahamnya."
            }, 
        ]
    },
    {
        title: "Screener",
        url: "screener",
        description: "Cari Saham sesuai Kriteria Kamu",
        icon: "landingicon_Screener.svg",
        features: [
            {
                title: "Guru Screener",
                description: 'Cari saham yang memenuhi kriteria "guru" investasi dunia seperti Warren Buffett, Peter Lynch, Piotroski dan lainnya.'
            },
            {
                title: "Preset Screener",
                description: "Screener Siap pakai untuk mencari saham dengan kriteria yang biasa digunakan oleh investor profesional."
            },
            {
                title: "100+ Rasio-rasio keuangan",
                description: "Data keuangan dan rasio keuangan yang lengkap sehingga kamu bisa menentukan sendiri kriteria saham yang kamu inginkan."
            },
            {
                title: "Ratio Vs Ratio",
                description: "Gunakan perbandingan dua rasio berbeda sebagai kriteria dari screener buatanmu."
            }, 
        ]
    },
    {
        title: "Price Alert",
        url: "price-alert",
        description: "Notifikasi Real-Time Saat Harga Kamu Tercapai",
        icon: "landingicon_Price-Alert.svg",
        features: [
            {
                title: "Push Notification",
                description: "Dapatkan notifikasi langsung di smartphone-mu saat harga saham mencapai harga yang telah kamu tentukan."
            },
            {
                title: "Real-Time Alert",
                description: "Notifikasi yang dikirimkan berdasarkan harga di bursa, sehingga kamu tidak akan ketinggalan momentum."
            }, 
        ]
    },
    {
        title: "Seasonality",
        url: "seasonality",
        description: "Lihat Pergerakan Saham Pada Bulan-bulan Tertentu",
        icon: "landingicon_Seasonality.svg",
        features: [
            {
                title: "Lebih dari 15 Tahun Price History",
                description: "Lihat kebiasaan pergerakan harga setiap bulan, hingga lebih dari 15 tahun kebelakang untuk mengetahui pada bulan apa biasanya harga cenderung naik atau turun."
            },
            {
                title: "Probabilitas Kenaikan",
                description: "Probabilitas kenaikan untuk setiap bulannya akan otomatis terhitung. Hint: $IHSG 100% positif pada bulan Desember selama 16 tahun terakhir."
            }, 
        ]
    },
    {
        title: "Earnings",
        url: "earnings",
        description: "Rangkuman Laba Bersih Perusahaan Setiap Periode",
        icon: "landingicon_Earnings.svg",
        features: [
            {
                title: "Tepat Waktu",
                description: "Lihat rekap laba bersih emiten pilihanmu langsung ketika emiten mengeluarkan laporan keuangan."
            },
            {
                title: "Bandingkan dengan Estimasi Analis",
                description: "Bandingkan laba bersih yang dilaporkan perusahaan dengan estimasi para analis. Apakah di atas estimasi atau di bawah estimasi?"
            },
            {
                title: "Bandingkan dengan Tahun Lalu",
                description: "Bandingkan hasil laba bersih pada kuartal saat ini dengan kuartal yang sama pada tahun sebelumnya."
            }, 
        ]
    },
    {
        title: "Comparison",
        url: "comparison",
        description: "Bandingkan Data Emiten Satu dengan Lainnya",
        icon: "landingicon_Comparison.svg",
        features: [
            {
                title: "Pembanding yang Sesuai",
                description: "Sistem kami secara otomatis akan membantu membandingkan emiten pilihan Anda dengan emiten sejenisnya sehingga tidak perlu lagi repot dan bingung mencari perbandingan emiten yang sesuai."
            },
            {
                title: "Komparasi Secara Rinci",
                description: "Dilengkapi dengan puluhan rasio dan financial metrics, laukan komparasi emiten dari berbagai aspek secara rinci dan mudah. Ditambah adanya angka rata-rata untuk masing-masing industri dan sektor emiten terkait sebagai pembanding untuk membantu memilih emiten yang paling sesuai dengan kriteria."
            }, 
        ]
    }, 
];



/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 55781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mr": function() { return /* reexport */ LandingPage_PageHeader; },
  "Dr": function() { return /* reexport */ LandingPage_SectionBrowser; },
  "ZG": function() { return /* reexport */ LandingPage_SectionContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
;// CONCATENATED MODULE: ./src/global/LandingPage/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 50px;\n  padding: 0 25px;\n  padding-top: 100px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 0;\n    padding-top: 120px;\n    width: calc(100% - 151px);\n  }\n\n  @media ",
        " {\n    margin-top: 0px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  padding: 50px 25px;\n  width: 100%;\n  max-width: 1300px;\n\n  @media ",
        " {\n    padding: 50px 30px;\n  }\n\n  @media ",
        " {\n    padding: 50px 0;\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-weight: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var HeaderWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    m: "auto",
    as: "header",
    direction: "column"
}).withConfig({
    componentId: "sc-182c2901-0"
})(_templateObject(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    m: "auto",
    as: "section"
}).withConfig({
    componentId: "sc-182c2901-1"
})(_templateObject1(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var HeaderTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    color: color/* default.primary */.Z.primary,
    size: "60px",
    height: 1.3,
    family: "bold",
    as: "h1"
}).withConfig({
    componentId: "sc-182c2901-2"
})(_templateObject2());
var HeaderDescription = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "19px",
    m: "0 auto",
    height: 1
}).withConfig({
    componentId: "sc-182c2901-3"
})(_templateObject3());


;// CONCATENATED MODULE: ./src/global/LandingPage/PageHeader/index.tsx


function PageHeader(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderTitle, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderDescription, {
                children: description
            })
        ]
    });
}
/* harmony default export */ var LandingPage_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/global/LandingPage/SectionBrowser/styled.ts
/* eslint-disable indent */ /* eslint-disable space-infix-ops */ 
function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  @media ",
        " {\n    padding: 50px 0;\n    padding-left: 50px;\n    width: 50%;\n  }\n\n  @media ",
        " {\n    width: 60%;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    align-items: flex-start;\n    margin-bottom: 0;\n    padding-right: 50px;\n    width: 50%;\n  }\n\n  @media ",
        " {\n    width: 40%;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        flex-direction: row-reverse;\n        ",
        " {\n          padding-left: 0;\n          padding-right: 50px;\n        }\n\n        ",
        " {\n          padding-left: 50px;\n          padding-right: 0;\n        }\n      "
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  @media ",
        " {\n    align-items: center;\n    flex-direction: row;\n\n    ",
        "\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin: auto;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    text-align: left;\n    margin: unset;\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: auto;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 18px;\n    margin: unset;\n    text-align: left;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var BrowserWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ea18046b-0"
})(styled_templateObject(), device/* default.laptop */.Z.laptop, device/* default.laptopL */.Z.laptopL);
var ContentWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-ea18046b-1"
})(styled_templateObject1(), device/* default.laptop */.Z.laptop, device/* default.laptopL */.Z.laptopL);
var SectionWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper).withConfig({
    componentId: "sc-ea18046b-2"
})(styled_templateObject3(), device/* default.laptop */.Z.laptop, function(param) {
    var reverse = param.reverse;
    return reverse && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject2(), BrowserWrapper, ContentWrapper);
});
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h2",
    size: "40px",
    family: "bold"
}).withConfig({
    componentId: "sc-ea18046b-3"
})(_templateObject4(), device/* default.laptop */.Z.laptop);
var Description = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    height: 1.3,
    color: color/* default.dimgray */.Z.dimgray
}).withConfig({
    componentId: "sc-ea18046b-4"
})(_templateObject5(), device/* default.laptop */.Z.laptop);


// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/LandingPage/BrowserBox/styled.ts

function BrowserBox_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);\n  margin: 20px 0;\n  max-width: 840px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n"
    ]);
    BrowserBox_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BrowserBox_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px 4px 0 0;\n  height: 24px;\n  padding: 6px 3px;\n\n  .browser-bullet {\n    background: #2f8ef7;\n    border-radius: 10px;\n    float: left;\n    height: 7px;\n    margin-left: 7px;\n    opacity: 0.8;\n    vertical-align: middle;\n    width: 7px;\n\n    :nth-child(1) {\n      background: #fc605c;\n    }\n    :nth-child(2) {\n      background: #fdbc40;\n    }\n    :nth-child(3) {\n      background: #34c84a;\n    }\n  }\n"
    ]);
    BrowserBox_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BrowserBox_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        " no-repeat center top / 100% auto;\n  border-radius: 4px;\n  box-shadow: inset 0 1px 1px rgb(0 0 0 / 10%);\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n\n  img {\n    width: 98%;\n    opacity: 0;\n  }\n"
    ]);
    BrowserBox_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var BoxWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-0"
})(BrowserBox_styled_templateObject(), color/* default.component */.Z.component);
var TabToolTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-1"
})(BrowserBox_styled_templateObject1());
var BrowserContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3b3c12d-2"
})(BrowserBox_styled_templateObject2(), color/* default.light */.Z.light);


;// CONCATENATED MODULE: ./src/global/LandingPage/BrowserBox/index.tsx



function BrowserBox(param) {
    var image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoxWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabToolTop, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "browser-bullet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserContent, {
                style: {
                    backgroundImage: "url(".concat(image, ")")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: image,
                    alt: "browser preview"
                })
            })
        ]
    });
}
/* harmony default export */ var LandingPage_BrowserBox = (BrowserBox);

;// CONCATENATED MODULE: ./src/global/LandingPage/SectionBrowser/index.tsx



function SectionBrowser(param) {
    var reverse = param.reverse, title = param.title, description = param.description, image = param.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionWrapper, {
        reverse: reverse,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowserWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPage_BrowserBox, {
                    image: image
                })
            })
        ]
    });
}
/* harmony default export */ var LandingPage_SectionBrowser = (SectionBrowser);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/global/LandingPage/SectionContent/styled.ts

function SectionContent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n  }\n"
    ]);
    SectionContent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  margin-bottom: 30px;\n  text-align: center;\n  width: 100%;\n\n  @media ",
        " {\n    align-items: flex-start;\n    margin-bottom: 0;\n    text-align: left;\n    width: calc((100% - 201px) / 3);\n  }\n"
    ]);
    SectionContent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: inherit;\n"
    ]);
    SectionContent_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionContent_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: no-repeat center right / 16px auto;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG2SURBVGhD7Zi/LwRREMcHodAo0BGNQohEoqBQEYma+AMUNm7eXaGQiMKV/AEKEqUf2XmH5HqNSqGi1BCdSkIkkuPM25uTW3ul4ibmk0wut+9bzCf73tt9C4ZhGIZhGMY/4jjqg2KxXf4ppApt4J3nqoLHRyCckBFlEM7UJOqFzxDjsIwqIi6MArmvlAy5BzgrDEhCEbHbTokkhbcs2S8JRRDuZWTIXUM56paEEmqL/igj4/ESqNglKSWEhsmVszK8q9Fyh6SUEKYS4VUTmf3krqmCop5ksWdldiTRhHPXC5SbbLmKcYEbf/klUuXrG9J5Ax7XuT4z4Vau8MwhtyIGTG2XyBrrqAo/e+bFhCF31ySkoe7TD8tSfoRlYh64adF65UpLED7BaW5QDBRQckvceCUtwi+UHsckoYA4P8sNf6Qlwt3BKUkoIDTr8S0twVJBTg2xG+emefo0SoTplVuUhAJKOJQs5EaJ5JyCq5JQQNhKw5baKJGI4KYkFBA+OIRzR1ZiVxJKOFubzkh4PNT3phvO5h7ffyQIL/SdPep4nOPpdcK/W3AQdcpVwzAMwzAMw/gLAL4BSNemrTyIDIIAAAAASUVORK5CYII=');\n  color: ",
        ";\n  font-size: 14px;\n  margin-bottom: 15px;\n  padding-right: 30px;\n\n  b {\n    font-family: var(--bold-font);\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    SectionContent_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-gap: 30px;\n  width: 100%;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-column-gap: 60px;\n  }\n\n  @media ",
        " {\n    margin-left: 100px;\n    width: calc(2 * ((100% - 101px) / 3));\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  text-align: center;\n  width: 100%;\n\n  @media ",
        " {\n    align-items: flex-start;\n    text-align: left;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 17px;\n  margin-bottom: 10px;\n\n  @media ",
        " {\n    font-size: 19px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: inherit;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}






var styled_SectionWrapper = (0,styled_components_browser_esm/* default */.ZP)(Wrapper).withConfig({
    componentId: "sc-8c176896-0"
})(SectionContent_styled_templateObject(), device/* default.laptop */.Z.laptop);
var TitleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-8c176896-1"
})(SectionContent_styled_templateObject1(), device/* default.laptop */.Z.laptop);
var styled_Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    as: "h3",
    family: "bold",
    size: "40px",
    mb: "10px",
    height: 1.2
}).withConfig({
    componentId: "sc-8c176896-2"
})(SectionContent_styled_templateObject2());
var styled_Description = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    as: "a",
    align: "center",
    wrap: "wrap"
}).withConfig({
    componentId: "sc-8c176896-3"
})(SectionContent_styled_templateObject3(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary);
var FeaturesWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8c176896-4"
})(styled_templateObject4(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
var FeatureItemWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-8c176896-5"
})(styled_templateObject5(), device/* default.laptop */.Z.laptop);
var FeatureItemTitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    family: "bold",
    as: "h4"
}).withConfig({
    componentId: "sc-8c176896-6"
})(_templateObject6(), device/* default.tablet */.Z.tablet);
var FeatureDescription = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    color: color/* default.dimgray */.Z.dimgray,
    size: "16px",
    height: 1.3
}).withConfig({
    componentId: "sc-8c176896-7"
})(_templateObject7());


;// CONCATENATED MODULE: ./src/global/LandingPage/SectionContent/index.tsx







function SectionContent(_param) {
    var title = _param.title, label = _param.label, icon = _param.icon, url = _param.url, features = _param.features, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "label",
        "icon",
        "url",
        "features"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_SectionWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Title, {
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Description, {
                            children: [
                                "Selengkapnya tentang \xa0 ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: title
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon,
                        alt: title,
                        style: {
                            width: "50px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturesWrapper, {
                children: features.map(function(feature) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureItemTitle, {
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureDescription, {
                                children: feature.description
                            })
                        ]
                    }, feature.title);
                })
            })
        ]
    }));
}
/* harmony default export */ var LandingPage_SectionContent = (SectionContent);

;// CONCATENATED MODULE: ./src/global/LandingPage/index.ts





/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 36305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);